export default __webpack_public_path__ + "f0cad90d3e860a9a183c8c77d6c21d67.png";